import { z } from "zod";
import { twinBatchMineSchema, twinDecisionKindSchema, twinProposalDiscussionSchema, twinProposalKindSchema, twinProposalReviewerSchema, twinProposalViewerSchema } from "./twin-proposals.js";
/*
 * Shared review (docs/specs/shared-review-reviewers.md): a review card can have several reviewers, the first decision
 * settles it for everyone, and the others' inboxes update. A card's reviewers and viewer, a decision's attribution
 * and a batch's reviewers and `mine` live on `twinProposalSchema`, `twinDecisionSchema` and `twinBatchSchema`, optional
 * there; the server always sends them. The types below are those objects with the fields present, plus where a card's
 * discussion lives and the decided event.
 */
const identifierSchema = z.string().trim().min(1).max(200);
export const twinSharedReviewProposalFieldsSchema = z.object({
    reviewers: z.array(twinProposalReviewerSchema).max(10),
    viewer: twinProposalViewerSchema,
    discussion: twinProposalDiscussionSchema,
}).strict();
export const twinSharedReviewBatchFieldsSchema = z.object({
    reviewerUserIds: z.array(identifierSchema).max(64),
    mine: twinBatchMineSchema,
}).strict();
/**
 * A card was decided, undone, or stood down. Sent as resource type `twin_proposal` with the card's id as the
 * resource id and, for workflow cards, its channel, so open cards and queues refresh in place.
 */
export const workspaceTwinProposalDecidedContextSchema = z.object({
    eventKind: z.literal("workspace.twin_proposal.decided"),
    schemaVersion: z.literal(1),
    payload: z.object({
        batchId: identifierSchema,
        kind: twinProposalKindSchema,
        decision: z.union([twinDecisionKindSchema, z.enum(["undone", "superseded", "expired"])]),
        actor: identifierSchema,
        actorName: z.string().trim().min(1).max(200).nullable(),
        decidedAs: z.enum(["reviewer", "admin"]).nullable(),
        decidedAt: z.number().int().nonnegative(),
    }).strict(),
}).strict();
